import React, {useEffect, useRef, useState} from "react";
import ImageBasic from "../../Common/Image/ImageBasic";
import IMG from "../../../constants/image";
import {clsx} from "clsx";
import {useDeliveryStore} from "../../../store/deliveryStore";
import {isEmpty} from "lodash";
import {text} from "../../../constants/text";

const fallbackPickupTimes = [
  {
    date: "Hôm nay (10/03)",
    pickupTime: 20260310,
    slots: [
      {pickupTimeRangeId: 1, pickupTimeRange: "09:00 - 11:00"},
      {pickupTimeRangeId: 2, pickupTimeRange: "13:00 - 15:00"},
    ],
  },
  {
    date: "Ngày mai (11/03)",
    pickupTime: 20260311,
    slots: [
      {pickupTimeRangeId: 3, pickupTimeRange: "09:00 - 11:00"},
      {pickupTimeRangeId: 4, pickupTimeRange: "13:00 - 15:00"},
    ],
  },
];

const PickupTimeSelector = ({handleSelectPickupTime, errors}) => {
  const {pickupTimes} = useDeliveryStore();
  const effectivePickupTimes = !isEmpty(pickupTimes) ? pickupTimes : fallbackPickupTimes;
  const [selectedTime, setSelectedTime] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
        inputRef.current && !inputRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = ({
                          date,
                          pickupTimeRange,
                          pickupTimeRangeId,
                          pickupTime
                        }) => {
    setSelectedTime({
      date,
      pickupTimeRange,
      pickupTimeRangeId
    });
    handleSelectPickupTime && handleSelectPickupTime(pickupTime, pickupTimeRangeId);
    setIsOpen(false);
  };

  // Format the selected time display
  const displayValue = selectedTime
    ? `${selectedTime.date} (${selectedTime.pickupTimeRange})`
    : text.selectCarrierPickupTime;

  return (
    <div className="pb-2">
      <div className="font-medium mb-2">{text.pickupTime}</div>
      <div className="relative">
        <div
          ref={inputRef}
          className="w-full p-3 border rounded-md text-gray-700 bg-white cursor-pointer flex items-center justify-between"
          onClick={() => setIsOpen(!isOpen)}
        >
                    <span className={selectedTime ? "text-black" : "text-gray-400"}>
                        {displayValue}
                    </span>
          <div className="pointer-events-none">
            <ImageBasic
              className={clsx(isOpen ? 'transform rotate-180' : '', 'transition-transform duration-200 w-4 h-4')}
              src={IMG.icon.chevronDown}
              alt='chevron down'/>
          </div>
        </div>
        {errors?.pickupTimeRangeId && (
          <div className='absolute bottom-[-22px] left-0 flex items-center gap-1'>
            <img src={IMG.icon.errorOutline} alt="errorOutline"/>
            <p className='text-[#E4626F] text-xs'>{errors?.pickupTimeRangeId}</p>
          </div>
        )}

        {isOpen && (
          <div
            ref={dropdownRef}
            className="absolute top-full left-0 right-0 mt-1 z-10 bg-white border rounded-md shadow-lg max-h-60 overflow-auto"
          >
            {!isEmpty(effectivePickupTimes) && effectivePickupTimes.map((dateGroup) => (
              <React.Fragment key={dateGroup.date}>
                {/* Time slots for this date */}
                {!isEmpty(dateGroup?.slots) && dateGroup?.slots?.map((slot) => (
                  <div
                    key={`${dateGroup.date}-${slot.pickupTimeRangeId}`}
                    className="flex space-x-2 p-3 hover:bg-gray-100 cursor-pointer pl-4"
                    onClick={() => handleSelect(
                      {
                        date: dateGroup.date,
                        pickupTime: dateGroup.pickupTime,
                        pickupTimeRange: slot.pickupTimeRange,
                        pickupTimeRangeId: slot.pickupTimeRangeId
                      }
                    )}
                  >
                    <div className='text-[#197D55] font-bold'>
                      {`${dateGroup?.date}`}
                    </div>
                    <div>{slot.pickupTimeRange}</div>
                  </div>
                ))}
              </React.Fragment>
            ))}

            {isEmpty(effectivePickupTimes) && (
              <div className="p-3 text-gray-500 text-center">
                {text.noDeliveryTimeSlots}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PickupTimeSelector;
